import React, { useRef } from 'react';
import s from './styles.module.scss';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { routes } from '@/infrastructure/const/routes';
import dynamic from 'next/dynamic';
import { IAppModalRef } from '@/components/common/modal';
import classNames from 'classnames';
import { replaceWords } from '@/utils/helpers/replace-words';

const AppModal = dynamic(() => import('@/components/common/modal/dynamic'), {
  ssr: false,
});
const ContactForm = dynamic(() => import('@/components/forms/contact'), {
  ssr: false,
});

const PRIVACY_POLICY_URL = process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL;
const TERMS_AND_CONDITION_URL = process.env.NEXT_PUBLIC_TERMS_AND_CONDITION_URL;
const ATHAN_PRO_URL = process.env.NEXT_PUBLIC_ATHAN_PRO_URL;

interface IAppFooterProps {
  className?: string;
}

const AppFooter: React.FC<IAppFooterProps> = (props) => {
  const { className = '' } = props;

  const { t: tLinks } = useTranslation('links');
  const { t: tCommon } = useTranslation('common');

  const modal = useRef<IAppModalRef>(null);

  const footerClassNames = classNames(s['footer'], className);

  const copyrightText = replaceWords(tCommon('copyright'), {
    year: `${new Date().getFullYear()}`,
  });

  const links = [
    {
      link: routes.ourApps,
      text: tLinks('ourApps'),
    },
    {
      link: routes.aboutUs,
      text: tLinks('aboutUs'),
    },
    {
      link: routes.support,
      text: tLinks('support'),
    },
  ];

  const openContactForm = () => {
    if (modal.current) {
      modal.current.open();
    }
  };
  const closeContactForm = () => {
    if (modal.current) {
      modal.current.close();
    }
  };

  return (
    <>
      <footer className={footerClassNames}>
        <div className={s['links']}>
          <button className={s['link']} onClick={openContactForm}>
            {tLinks('contactUs')}
          </button>
          <span className={s['link']}>
            <a target="_blank" href={PRIVACY_POLICY_URL}>
              {tLinks('privacy')}
            </a>{' '}
            &{' '}
            <a target="_blank" href={TERMS_AND_CONDITION_URL}>
              {tLinks('termOfService')}
            </a>
          </span>
          {links.map((link, index) => (
            <Link
              key={index}
              className={s['link']}
              href={link.link}
              prefetch={false}
              passHref
            >
              {link.text}
            </Link>
          ))}
          <a
            className={s['link']}
            target="_blank"
            rel="noopener"
            href={ATHAN_PRO_URL}
          >
            {tLinks('athanPro')}
          </a>
        </div>
        <p className={s['copyright']}>{copyrightText}</p>
      </footer>
      <AppModal forwardedRef={modal}>
        <ContactForm onClose={closeContactForm} />
      </AppModal>
    </>
  );
};

export default AppFooter;
